import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_ds_reports_listService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { required_inputs?: { owner?: boolean, project?: boolean, material?: boolean, warehouse?: boolean, location?: boolean, date_count?: number, string_count?: number, number_count?: number }, context?: string, allowed_reports?: { module_id: string, report_id: string }[], $top?: number, $skip?: number }): Promise<{ result?: { report_id?: string, module_id?: string, description?: string, title?: string, config_id?: string }[], totalCount?: number }> {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { required_inputs?: { owner?: boolean, project?: boolean, material?: boolean, warehouse?: boolean, location?: boolean, date_count?: number, string_count?: number, number_count?: number }, context?: string, allowed_reports?: { module_id: string, report_id: string }[], $keys: { report_id?: string, module_id?: string }[] }): Promise<{ result?: { report_id?: string, module_id?: string, description?: string, title?: string, config_id?: string }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      required_inputs?: { owner?: boolean, project?: boolean, material?: boolean, warehouse?: boolean, location?: boolean, date_count?: number, string_count?: number, number_count?: number }, context?: string, allowed_reports?: { module_id: string, report_id: string }[]    }) {
      return false;
    }
}
